module.exports = __webpack_public_path__ + "static/img/twjd-sdw2.de9a973.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdw2.png
// module id = 152
// module chunks = 0